export function scrollToTop() {
    if ("scrollBehavior" in document.documentElement.style) {
        const isFirefox = navigator.userAgent.toLowerCase().includes("firefox");

        if (isFirefox) {
            window.scrollTo(0, 0);
        }

        // Smooth scroll to top using modern browsers
        window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
        // Fallback for older browsers - instant scroll
        window.scrollTo(0, 0);
    }
}
